module.exports = __webpack_public_path__ + "static/media/500.5e46b1dd.svg";